import * as React from 'react'

import { Select, SelectItem } from '../../../components'
import { columnMap } from '../constants/columns'
import { ColumnId } from '../types'

interface FilterSelectProps<ValueType> {
  filterColumn: ColumnId
  selected?: ValueType
  options: Array<SelectItem<ValueType>>
  onChange: (value: SelectItem<ValueType>) => void
}

export function FilterSelect<ValueType extends string | number>({
  filterColumn,
  selected,
  options,
  onChange,
}: FilterSelectProps<ValueType>) {
  /**
   * `selected` comes from loader. We set the selection to state in order to have
   * immediate response to user action. We also need to set the selection in an effect
   * so that back/forward works correctly.
   */
  const [filterValue, setFilterValue] = React.useState(selected)
  React.useEffect(() => {
    setFilterValue(selected)
  }, [selected])

  return (
    <Select
      className="w-full"
      placement="bottom"
      aria-label={`${columnMap[filterColumn].name} select`}
      value={filterValue}
      items={options}
      onChange={(item) => {
        setFilterValue(item.value)
        onChange(item)
      }}
    />
  )
}
